import { render } from "./ComplaintDialog.vue?vue&type=template&id=3b9d9e3f"
import script from "./ComplaintDialog.vue?vue&type=script&lang=js"
export * from "./ComplaintDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__